import { useState, useRef, useEffect, type FormEvent } from 'react';
import { observer } from 'mobx-react-lite';
import { useParams } from 'react-router';
import { useStore } from '@/app/StoreContext';
import { Input } from '@/components/ui/Input';
import { Button } from '@/components/ui/Button';
import { ScoreFlash } from './ScoreFlash';
import styles from './WordInput.module.css';

export const WordInput = observer(function WordInput() {
  const [value, setValue] = useState('');
  const { round, ui } = useStore();
  const { code } = useParams<{ code: string }>();
  const formRef = useRef<HTMLFormElement>(null);

  const dangerBorder = ui.flashState?.kind === 'rejected';

  useEffect(() => {
    if (ui.flashState?.kind !== 'rejected') return;
    const el = formRef.current;
    if (!el) return;
    el.classList.remove(styles.shaking);
    void el.offsetWidth; // force reflow to restart animation
    el.classList.add(styles.shaking);
  }, [ui.flashState?.id]); // eslint-disable-line react-hooks/exhaustive-deps

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    if (!code || !value.trim()) return;
    const word = value;
    setValue('');
    try {
      await round.submitWord(code, word);
    } catch {
      setValue(word);
    }
  };

  return (
    <div className={styles.dock}>
      <ScoreFlash />
      <form
        ref={formRef}
        onSubmit={submit}
        className={styles.form}
        onAnimationEnd={e => e.currentTarget.classList.remove(styles.shaking)}
      >
        <Input
          value={value}
          onChange={e => setValue(e.target.value)}
          placeholder="Введи слово…"
          aria-label="Введите слово"
          autoFocus
          disabled={!round.isActive}
          inputMode="text"
          autoComplete="off"
          autoCapitalize="off"
          autoCorrect="off"
          spellCheck={false}
          data-word-input=""
          className={dangerBorder ? styles.inputDanger : undefined}
        />
        <Button
          type="submit"
          disabled={!round.isActive || !value.trim()}
          loading={round.isSubmitting}
          className={styles.submitBtn}
        >
          ↑
        </Button>
      </form>
    </div>
  );
});
